import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_QUERY_KEY } from './useGetMerchandisingCollection';
import { MERCHANDISING_COLLECTIONS_QUERY_KEY } from './useGetMerchandisingCollections';

import MerchandisingCollectionsService from '@/services/MerchandisingCollectionsService';

export function useRemoveMerchandisingCollection() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: number) =>
      MerchandisingCollectionsService.removeCollection(id),
    onSuccess: (_data, variables) => {
      const id = variables;

      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTIONS_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: [...MERCHANDISING_COLLECTION_QUERY_KEY, id],
      });
    },
  });

  return {
    removeMerchandisingCollection: mutateAsync,
    isLoading: isPending,
  };
}
